import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { PhoneNumberType, PhoneNumberUtil } from 'google-libphonenumber';
import { EMAIL_VALID_REGEXP } from './general.service';
const phoneUtil = PhoneNumberUtil.getInstance();

export class ValidatorService {
  static emailValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const value = control.value;
      if (!value) return null;
      const errors: ValidationErrors = {};
      if (!EMAIL_VALID_REGEXP.test(value)) errors.email = true;
      return Object.keys(errors).length ? errors : null;
    };
  }

  static phoneValidator(areaCode: string): ValidatorFn {
    console.warn('areaCode', areaCode);
    return (control: AbstractControl): ValidationErrors | null => {
      const phone = control.value;

      if (!phone || typeof phone !== 'string') {
        return { invalidPhone: true };
      }

      const normalizedAreaCode = areaCode.startsWith('+') ? areaCode.substring(1) : areaCode;

      let regionCode = '';
      try {
        regionCode = phoneUtil.getRegionCodeForCountryCode(+normalizedAreaCode);
      } catch {
        return { invalidPhone: true };
      }

      if (!regionCode || regionCode.toUpperCase() === 'ZZ') {
        return { invalidPhone: true };
      }

      try {
        const phoneNumber = phoneUtil.parse(phone, regionCode);
        const isValid = phoneUtil.isValidNumber(phoneNumber);
        const type = phoneUtil.getNumberType(phoneNumber); // 0: FIXED_LINE, 1: MOBILE, 2: FIXED_LINE_OR_MOBILE

        const validTypes = [PhoneNumberType.FIXED_LINE, PhoneNumberType.MOBILE, PhoneNumberType.FIXED_LINE_OR_MOBILE];

        if (isValid && validTypes.includes(type)) {
          return null;
        }
      } catch {
        return { invalidPhone: true };
      }

      return { invalidPhone: true };
    };
  }

  static passwordStrengthValidator(): ValidatorFn {
    return (control): ValidationErrors | null => {
      const value = control.value || '';

      const errors: ValidationErrors = {};

      if (value.length < 8 || value.length > 20) {
        errors.range = true;
      }

      if (!/[A-Z]/.test(value)) errors.capital = true;
      if (!/\d/.test(value)) errors.number = true;

      return Object.keys(errors).length ? errors : null;
    };
  }

  // matchTo為要比對對象的control name
  static matchValidator(matchTo: string): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      if (!control?.parent) return null;

      const targetValue = control.value;
      const matchValue = control.parent.get(matchTo)?.value;

      return targetValue !== matchValue ? { match: true } : null;
    };
  }
}
